<mat-card>
  <app-card-header
    title="Asignar grupo por zona"
    icono="group_add"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (cargando) {
      <div class="cargando">
        <mat-spinner diameter="22"></mat-spinner>
        <span>
          Buscando {{ data.etiqueta ?? 'entidades' }} dentro de la zona…
        </span>
      </div>
    } @else if (dentro === 0) {
      <p class="agz-texto">
        No hay {{ data.etiqueta ?? 'entidades' }} dentro de la zona dibujada.
      </p>
    } @else {
      <p class="agz-texto">
        <b>{{ dentro }}</b>
        {{ data.etiqueta ?? 'entidades' }} dentro del polígono. Elegí el grupo,
        tildá las que quieras y asigná o quitá.
      </p>

      <section class="inputs-group">
        <app-grupo-selector
          style="flex: 1; min-width: 0"
          [categoria]="data.categoria"
          [idCliente]="data.idCliente ?? null"
          [multiple]="false"
          [(ngModel)]="idGrupo"
          [disabled]="asignando"
        ></app-grupo-selector>
      </section>

      <div class="lista-header">
        <mat-checkbox
          color="primary"
          [checked]="todasSel"
          [indeterminate]="seleccionadas > 0 && !todasSel"
          [disabled]="asignando"
          (change)="toggleTodas($event.checked)"
        >
          Seleccionar todas
        </mat-checkbox>
        <span class="contador">{{ seleccionadas }} / {{ dentro }}</span>
      </div>

      <div class="lista">
        @for (item of items; track item.entidad['_id']) {
          <div class="item-row">
            <mat-checkbox
              color="primary"
              [(ngModel)]="item.sel"
              [disabled]="asignando"
            >
              {{ item.label }}
            </mat-checkbox>
            <div class="chips">
              @for (chip of chipsDe(item.entidad); track chip.nombre) {
                <span class="chip" [class.elegido]="chip.esElegido">
                  <span class="dot" [style.background]="chip.color"></span>
                  {{ chip.nombre }}
                </span>
              } @empty {
                <span class="sin">sin grupo</span>
              }
            </div>
          </div>
        }
      </div>

      @if (asignando) {
        <div class="cargando">
          <mat-spinner diameter="22"></mat-spinner>
          <span>Asignando… puede tardar según la cantidad.</span>
        </div>
      }
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" (click)="cerrar()" [disabled]="asignando">
      Cancelar
    </button>
    <button
      irxBoton="peligro-borde"
      [disabled]="!idGrupo || !seleccionadas || asignando || cargando"
      (click)="aplicar('quitar')"
      tooltip="Quitar este grupo de las seleccionadas"
    >
      <mat-icon>group_remove</mat-icon>
      Quitar de {{ seleccionadas }}
    </button>
    <button
      irxBoton="principal"
      [disabled]="!idGrupo || !seleccionadas || asignando || cargando"
      (click)="aplicar('asignar')"
    >
      @if (asignando) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <mat-icon>group_add</mat-icon>
      }
      Asignar a {{ seleccionadas }}
    </button>
  </mat-card-actions>
</mat-card>
